import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle} from './puzzle.js';
import {MalAnimation} from './mal-animation.js';
import {WLUtils} from '../utils/WLUtils.js';
import {FailStateNames} from '../enums/FailStateNames.js';
import {FruitPrefabs} from './fruit-prefabs.js';
import {BombPower} from './special-powers/bomb-power.js';

export class FallingObjectsSpawner extends Component {
    static TypeName = 'falling-objects-spawner';

    private _puzzle: Puzzle;
    private _mal: MalAnimation;

    private _nextPieces: Object3D[] = [];

    private _lastPieceWasBomb: boolean;
    public get lastPieceWasBomb(): boolean {
        return this._lastPieceWasBomb;
    }

    public paused = false;

    start() {}

    initialize() {}

    setup(puzzleController: Puzzle) {
        this._puzzle = puzzleController;
        this._mal = this._puzzle.nextFruitSlot.getComponent(MalAnimation);

        this._puzzle.registerResetGameCallback(this.resetGame);
        this._lastPieceWasBomb = false;
    }

    spawn(): boolean {
        let success = false;
        if (!this.paused) {
            success = true;
            this._mal.drop();

            if (this._nextPieces.length == 0) {
                this._queueNextPiece(this.spawnNext(), false);
                success = this._nextPieces.length > 0;
            }
        }

        return success;
    }

    queueTop(): Object3D {
        let result = null;

        if (this._nextPieces.length > 0) {
            result = this._nextPieces[0];
        }

        return result;
    }

    popNext() {
        this._lastPieceWasBomb =
            WLUtils.getComponentsOfTypeRecursive(this._nextPieces[0], BombPower).length > 0;
        this._nextPieces.shift();
        if (this._nextPieces.length == 0) {
            this._queueNextPiece(this.spawnNext(), false);
        }
    }

    returnToQueue(piece: Object3D) {
        if (piece) {
            if (this._nextPieces.length > 0) {
                this._nextPieces.splice(1, 0, piece);
                WLUtils.setActive(piece, false);
            } else {
                this._nextPieces.splice(0, 0, piece);
                WLUtils.setActive(piece, true);
            }
        }
    }

    startGame() {
        const first = this.spawnNext();
        if (first != null) {
            this._nextPieces.push(first);
        }

        if (this._mal) {
            this._mal.load();
        }
    }

    gameOver(cause: FailStateNames) {
        if (this._mal) {
            this._mal.die(cause);
        }
    }

    queuePiece(prefab: string): void {
        const obj = FruitPrefabs.instance.spawn(prefab);
        this._queueNextPiece(obj, true);
    }

    protected spawnNext(): Object3D {
        return null;
    }

    protected resetGame = (puzzleController: Puzzle) => {
        if (this._mal) {
            this._mal.resetMal();
        }

        // clear the queue
        for (let x = 0; x < this._nextPieces.length; x++) {
            this._nextPieces[x].destroy();
            this._nextPieces[x] = null;
        }

        this._nextPieces.length = 0;

        puzzleController.unregisterResetGameCallback(this.resetGame);
        this.object.destroy(); // GameFlowController will destroy this anyway, but this makes it certain.
    };

    protected _queueNextPiece(nextPiece: Object3D, addToTop: boolean) {
        if (nextPiece) {
            WLUtils.setActive(nextPiece, false);

            if (addToTop) {
                //replace top most thing
                if (this._nextPieces.length > 0) {
                    WLUtils.setActive(this._nextPieces[0], false);
                }
                // insert in front of the array
                this._nextPieces.splice(0, 0, nextPiece);
                this._mal.load();
            } else {
                this._nextPieces.push(nextPiece);
            }
        }
    }
}
